// Note: The first file of a module here, must also register the module

import "./division-create-dialog.component";
import "./division-list.component";
import "./division-map.component";
import "./division-switch.component";
import "./division-users-list.component";
import "./divisions.component";
